import SignaturePad from 'react-signature-canvas';

const MIN_STROKE_DISTANCE = 50;
const MIN_DATA_LENGTH = 250;

type SignaturePoint = { x: number; y: number };
type SignatureStroke = { points?: SignaturePoint[] } | SignaturePoint[];

function getTotalStrokeDistance(data: SignatureStroke[]): number {
  let totalDistance = 0;
  data.forEach((stroke) => {
    const points = Array.isArray(stroke)
      ? stroke
      : Array.isArray(stroke?.points)
        ? stroke.points
        : [];
    if (points.length > 1) {
      for (let i = 1; i < points.length; i += 1) {
        const dx = points[i].x - points[i - 1].x;
        const dy = points[i].y - points[i - 1].y;
        totalDistance += Math.sqrt(dx * dx + dy * dy);
      }
    }
  });
  return totalDistance;
}

function getSignatureDataLength(signatureData: string): number {
  if (!signatureData) return 0;
  const base64Parts = signatureData.split(',');
  if (base64Parts.length < 2 || !base64Parts[1]) return 0;
  return base64Parts[1].length;
}

export function getSignatureDataUrl(
  sigPad: SignaturePad | null,
  fallback = ''
): string {
  if (!sigPad || sigPad.isEmpty()) return fallback;

  try {
    return sigPad.getTrimmedCanvas().toDataURL('image/png');
  } catch (_error) {
    return fallback;
  }
}

export function isSignatureValid(
  sigPad: SignaturePad | null,
  signatureData: string
): boolean {
  if (!sigPad || sigPad.isEmpty() || !signatureData) return false;
  const dataLength = getSignatureDataLength(signatureData);
  if (dataLength === 0) return false;
  const strokeDistance = getTotalStrokeDistance(sigPad.toData());
  return strokeDistance > MIN_STROKE_DISTANCE && dataLength >= MIN_DATA_LENGTH;
}
